"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const radio_dispatch_1 = require("@clearsummit/radio-dispatch");
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const base_form_1 = __importDefault(require("@/components/base-form"));
const buttons_1 = require("@/components/base-form/buttons");
const fields_1 = require("@/components/base-form/fields");
const form_error_1 = __importDefault(require("@/components/base-form/form-error"));
const constants_1 = __importDefault(require("@/constants"));
const services_1 = require("@/helpers/services");
const api_payloads_1 = require("@/redux/api-payloads");
const field_names_1 = require("../field-names");
const schemas_1 = require("../schemas");
const styles_scss_1 = __importDefault(require("./styles.scss"));
const initialValues = {
    [field_names_1.SupportFieldNames.message]: '',
};
const SupportForm = ({ type, pending }) => (react_1.default.createElement("div", { className: styles_scss_1.default.supportForm },
    react_1.default.createElement(base_form_1.default, { initialValues: initialValues, validationSchema: schemas_1.SupportSchema, onSubmitPayload: ({ message }) => {
            const payload = {
                message,
                type
            };
            return api_payloads_1.sendSupportMessagePayload(payload);
        }, formKey: services_1.endpoints.sendSupportMessage },
        react_1.default.createElement(fields_1.TextAreaField, { className: styles_scss_1.default.textarea, ariaLabel: constants_1.default.support.typeYourMessage, placeholder: constants_1.default.support.typeYourMessage, numberOfLines: 6, label: constants_1.default.support.message, name: field_names_1.SupportFieldNames.message }),
        react_1.default.createElement(buttons_1.SubmitButton, { className: styles_scss_1.default.sendBtn, title: constants_1.default.support.send, ariaLabel: constants_1.default.support.send, disableOnErrors: true, disabled: pending }),
        react_1.default.createElement(form_error_1.default, { formKey: services_1.endpoints.sendSupportMessage }))));
SupportForm.defaultProps = {
    pending: false
};
const mapStateToProps = (state) => ({
    pending: radio_dispatch_1.selectors.getPending(state, services_1.endpoints.sendSupportMessage),
});
exports.default = react_redux_1.connect(mapStateToProps, null)(SupportForm);
